import {BLOG_CONSTS, AUTH_CONSTS} from "../constants";

export const initialState = {
    blogs: {
        itemsList: [],
        hasMore: false,
        badge : undefined,
    },
    blogsInModal: {
        itemsList: [],
        hasMore: false,
        badge : undefined,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BLOG_CONSTS.GET_BLOGS:
            return {
                ...state,
                blogs: {
                    itemsList: action.payload.reset ? action.payload.data : [...state.blogs.itemsList, ...action.payload.data],
                    badge: action.payload.badge,
                    hasMore: action.payload.hasMore
                }
            };
        case BLOG_CONSTS.GET_BLOGS_IN_MODAL:
            return {
                ...state,
                blogsInModal: {
                    itemsList: action.payload.reset ? action.payload.data : [...state.blogs.itemsList, ...action.payload.data],
                    hasMore: action.payload.hasMore
                }
            };
        case BLOG_CONSTS.ADD_BLOG:
            return {
                ...state,
                blogs: {
                    ...state.blogs,
                    itemsList: [action.payload, ...state.blogs.itemsList],
                }
            };
        case BLOG_CONSTS.UPDATE_BLOG:
            return {
                ...state,
                blogs: {
                    ...state.blogs,
                    itemsList: state?.blogs?.itemsList?.map(product => product.id === action.payload.id ?
                        action.payload : product)
                }
            };
        case BLOG_CONSTS.DELETE_BLOG:
            return {
                ...state,
                blogs: {
                    ...state.blogs,
                    itemsList: state.blogs.itemsList.filter(product => product.id !== action.payload),
                }
            };
        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
